export const listingBookingSettings = {
  section01: {
    title: "Direktbuchungen für dieses Inserat",
  },
  motor: {
    activeTitle: "Buchungsmaschine aktiv",
    inactiveTitle: "Buchungsmaschine inaktiv",
    activeDesc: "Gäste können dieses Inserat direkt über seinen Link buchen.",
    inactiveDesc: "Direktbuchungen sind für dieses Inserat deaktiviert.",
    statusOn: "Aktiv",
    statusOff: "Inaktiv",
  },
  payment: {
    title: "Wann zahlt der Gast?",
    onArrival: {
      name: "Zahlung bei Anreise",
      hint: "Kostenlos buchen, bei Anreise zahlen.",
    },
    online: {
      name: "Online zahlen",
      hint: "Zahlung bei Bestätigung der Buchung.",
    },
  },
  common: {
    saving: "Wird gespeichert…",
    onlyOnlineBadge: "Nur Online-Zahlung",
  },
  hold: {
    title: "Reservierungsdauer",
    desc: "Der Kalender wird blockiert, während der Gast die Zahlung abschließt.<br>Wird nicht innerhalb der festgelegten Zeit gezahlt, <strong>wird die Verfügbarkeit automatisch wieder freigegeben</strong>.",
  },
  units: {
    min: "Min.",
    hour: "Stunde",
    hours: "Stunden",
  },
  partial: {
    title: "Teilzahlung",
    cardTitle: "Bei der Buchung nur einen Teil zahlen lassen",
    descOn: "<strong>Aktiviert.</strong> Der Gast kann jetzt <strong>{percent} %</strong> zahlen und den Rest vor der Anreise (oder alles auf einmal).",
    descOff: "<strong>Deaktiviert.</strong> Der Gast zahlt bei der Buchung den <strong>Gesamtbetrag</strong>.",
    blockTitle: "Der Rest wird in der Unterkunft gezahlt",
    blockOn: "<strong>Aktiviert.</strong> Der Gast zahlt online <strong>nur {percent} %</strong>; der Rest wird <strong>bei der Anreise</strong> gezahlt (eine vollständige Online-Zahlung ist nicht möglich).",
    blockOff: "<strong>Deaktiviert.</strong> Der Gast kann wählen, ob er online {percent} % oder den Gesamtbetrag zahlt.",
  },
  reminder: {
    title: "Erinnerung an den Restbetrag",
    cardTitle: "Erinnerung zur Zahlung des offenen Betrags senden",
    daysBefore: "{count} Tag vor | {count} Tage vor",
    descOn: "<strong>Aktiviert.</strong> <strong>{daysBefore}</strong> der Anreise (gegen 09:00 Uhr, Ortszeit der Unterkunft) erhält der Gast per <strong>WhatsApp und E-Mail</strong> einen Link zur Zahlung des offenen Betrags.",
    descOff: "<strong>Deaktiviert.</strong> Der Gast erhält vor der Anreise keine Erinnerung, den Restbetrag online zu zahlen.",
    daysLabel: "Tage vor der Anreise",
    hint: "Wird nur einmal gesendet und nur an Gäste mit offenem Betrag. Wenn der Rest in der Unterkunft gezahlt wird, wird sie nicht gesendet.",
  },
  approve: {
    title: "Buchungen genehmigen",
    cardTitle: "Jede Buchung vor der Bestätigung genehmigen",
    descOn: "<strong>Aktiviert.</strong> Jede Buchung bleibt <strong>bis zu Ihrer Genehmigung offen</strong>: Sie erhalten eine Benachrichtigung und entscheiden, ob Sie sie annehmen oder ablehnen. Sie wird erst bestätigt, wenn Sie sie genehmigen.",
    descOff: "<strong>Deaktiviert.</strong> Buchungen werden nach Abschluss der Zahlung <strong>automatisch bestätigt</strong>. Aktivieren Sie die Option, wenn Sie jede Anfrage lieber selbst prüfen und genehmigen möchten.",
  },
  toasts: {
    statusUpdatedAll: "Status in allen Einheiten aktualisiert.",
    statusUpdated: "Status aktualisiert.",
    statusError: "Aktualisierung nicht möglich.",
    paymentUpdated: "Zahlungsart aktualisiert.",
    paymentError: "Die Zahlungsart konnte nicht gespeichert werden.",
    partialUpdated: "Teilzahlung aktualisiert.",
    partialError: "Die Teilzahlung konnte nicht gespeichert werden.",
    reminderUpdated: "Erinnerung aktualisiert.",
    reminderError: "Die Erinnerung konnte nicht gespeichert werden.",
    saved: "Gespeichert.",
    saveError: "Speichern nicht möglich.",
    linkCopied: "Link kopiert.",
    copyError: "Kopieren nicht möglich.",
  },
  share: {
    whatsappText: "Hallo 👋 Hier ist der Link zum Buchen: {link}",
  },
};
